import React, { useEffect, useState } from 'react';

import {
  extractApiError,
  formatCountdown,
  promotionService,
} from '../services/promotionService';

const COUNTDOWN_REFRESH_MS = 30000;

interface ShareCooldownNoticeProps {
  isSystemAdmin: boolean;
  nextShareAt: string | null;
  refresh: () => void;
}

export const ShareCooldownNotice: React.FC<ShareCooldownNoticeProps> = (props) => {
  const [now, setNow] = useState(() => Date.now());
  const [resetting, setResetting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), COUNTDOWN_REFRESH_MS);

    return () => window.clearInterval(timer);
  }, []);

  const resetCooldown = () => {
    setResetting(true);
    setError(null);
    void promotionService.resetShareCooldown()
      .then(() => props.refresh())
      .catch((err) => setError(extractApiError(err, 'Could not reset the share timer.')))
      .finally(() => setResetting(false));
  };

  return (
    <div className="promo-next-share">
      <div>You&apos;ve shared today. Next share available {formatCountdown(props.nextShareAt, now)}.</div>
      {props.isSystemAdmin && (
        <button
          className="promo-reset-timer-btn"
          disabled={resetting}
          onClick={resetCooldown}
          type="button"
        >
          {resetting ? 'Resetting…' : 'Reset timer (admin)'}
        </button>
      )}
      {error && <div className="promo-reset-timer-error">{error}</div>}
    </div>
  );
};
